module.exports = __webpack_public_path__ + "static/media/feather_gradient.0c6e3cec.svg";